"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var assignRef = function assignRef(ref, value) {
  if (ref == null) {
    return false;
  }

  if (typeof ref === 'function') {
    ref(value);
    return true;
  }

  try {
    // It's now ok to mutate `ref.current`
    // https://reactjs.org/docs/hooks-faq.html#is-there-something-like-instance-variables
    // eslint-disable-next-line no-param-reassign
    ref.current = value;
  } catch (error) {
    throw new Error("Cannot assign value \"".concat(value, "\" to ref \"").concat(ref, "\""));
  }

  return true;
};

var _default = assignRef;
exports.default = _default;